<div class="row me-0 " xmlns="http://www.w3.org/1999/html">
    <div class="offset-1 col-10">
      <h2>Leads</h2>
      <div class="position-sticky bg-white pb-3">
        <div class="mt-5 row no-gutters">
          <div class="col-9 d-flex gap-16 pb-2 border-top pt-3 mt-2 filters">

            <mat-form-field appearance="fill" class="font-14" [ngClass]="{'pointer-ev-none': hasSearched}">
              <mat-label class="mediumGray">Statut</mat-label>
              <mat-select [formControl]="statusFC">
                <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let value of statusList" (click)="hasChangedFilter = true; doFilter()" [value]="value">{{printStatus(value)}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="font-14" [ngClass]="{'pointer-ev-none': hasSearched}">
              <mat-label class="mediumGray">Propriétaire</mat-label>
              <mat-select [formControl]="contactFC">
                <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let value of agentList" (click)="hasChangedFilter = true; doFilter()" [value]="value.id.toString()">{{value.firstname + ' '  + value.lastname}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="font-14" [ngClass]="{'pointer-ev-none': hasSearched}">
              <mat-label class="mediumGray">Métropole</mat-label>
              <mat-select [formControl]="metropoleFC">
                <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let value of metropoleList" (click)="hasChangedFilter = true; doFilter()" [value]="value.name">{{value.name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="font-14" [ngClass]="{'pointer-ev-none': hasSearched}">
              <mat-label class="mediumGray">Partenaire</mat-label>
              <mat-select [formControl]="partnerFC">
                <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let value of partnerList" (click)="hasChangedFilter = true; doFilter()" [value]="value.id.toString()">{{value.name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <div class="dropdown px-3 text-start py-0 font-14 d-sm-flex align-items-center border-grey bg-white border-1 text-nowrap">
              <button style="height:39px" (click)="dispDateFilter = !dispDateFilter" class="dropbtn btn rounded-pill">
                {{dispoFilter ? 'Date : ' + dispoFilter : 'Date last update'}}
              </button>
              <div *ngIf="dispDateFilter" id="dateDropDown" class="dateDropDown">
                <div>
                  <input (change)="hasChangedFilter = true; doFilter(); dispDateFilter = !dispDateFilter" type="radio" id="dispoFilterAll" name="disponibility" [(ngModel)]="dispoFilter" [value]="null"/>
                  <label  class="ps-2" for="dispoFilterAll"> Tous </label><br />

                  <input type="radio" id="dispoFilterDate" name="disponibility" [(ngModel)]="dispoFilter" [value]="'date'"/>
                  <label class="ps-2" for="dispoFilterDate"> Plage de date  </label><br />

                </div>
                <mat-form-field class="rangeInput" *ngIf="dispoFilter == 'date' ">
                  <mat-label>Enter a date range</mat-label>
                  <mat-date-range-input  [formGroup]="dateRange" [rangePicker]="picker">
                    <input matStartDate formControlName="start" placeholder="Start date">
                    <input matEndDate formControlName="end" placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle class="fixPosition" matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <button *ngIf="dispoFilter == 'date'" (click)="hasChangedFilter = true; doFilter();dispDateFilter = !dispDateFilter" class="btn btn-sm btn-primary">Ok</button>
              </div>
            </div>


            <mat-form-field appearance="fill" class="font-14" [ngClass]="{'pointer-ev-none': hasSearched}">
              <mat-label class="mediumGray">Page vue</mat-label>
              <mat-select [formControl]="pageViewFC">
                <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let value of pageViewList" (click)="hasChangedFilter = true; doFilter()" [value]="value">{{printPageView(value)}}</mat-option>

              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3 text-end pt-2 pe-3 border-top pt-3 mt-2">
            <button class="btn btn-danger" (click)="clearAll()">Clear</button>
          </div>
        </div>
      </div>
      <div class="flex-grow-1 d-flex align-items-center justify-content-center" *ngIf="isLoading">
        <div class="spinner-border text-primary"></div>
      </div>

      <div class="row col-12 mb-5 pt-2" *ngFor="let lead of leadArray">
        <div class="col-1 border-end text-center">
          <div>
            <img width="64" [src]="getAgentAvatar(lead.user?.agent_id,'img')"/>
            <div class="mt-2"><small><b>{{getAgentAvatar(lead.user?.agent_id, 'name')}}</b></small></div>
            <div class="br-24 profile-image mt-2 p-2  avatarPlaceholder avatar-{{getPageReached(lead.leads)}}">
              <small>{{getPageReached(lead.leads)}}</small>
            </div>
          </div>
        </div>
        <div class="col-2 row border-end text-start">
          <div class="col-12 text-start">
            <h4 class="fw-bold">{{lead.user.firstname}} {{lead.user.lastname}}</h4>
            <div class="row">
              <div class="col-6 text-start fw-bold"><small>#{{lead.user.id}}</small></div>
            </div>
            <div class="py-2">
              <small>{{lead.user.email}}</small><br/>
              <small>{{lead.user.phone}}</small>
              <div *ngIf="lead.user.stayDuration" class="text-primary">
                <b><small>{{lead.user.stayDuration}} mois</small>
              </b>
              </div>
            </div>
            <div class="py-2">
              <div class="row">
                <div class="col-2 pb-2">
                  <a target="_blank" rel="noopener noreferrer" class="me-4" [ngClass]="{'disabled' : !lead.user?.crmId}"
                     href="https://app.hubspot.com/contacts/2665222/contact/{{lead.user?.crmId}}">
                    <img width="32" src="/assets/img/admin/picto/logo_hub.png"/>
                  </a>
                </div>
                <div class="col-2 pb-2">
                  <a target="_blank" rel="noopener noreferrer" [ngClass]="{'disabled' : !lead.user?.phone}"
                     href="https://api.whatsapp.com/send?phone={{lead.user?.phone}}">
                    <img width="32" src="/assets/img/admin/picto/logo_whatsapp.png"/>
                  </a>
                </div>
                <div class="col-2 pb-2">
                  <a target="_blank" rel="noopener noreferrer" href="/admin/users/{{lead.user.id}}">
                    <img class="pointer" width="32" src="/assets/img/admin/picto/logo1.png"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-7 row">
          <div class="row col-12 border-bottom" *ngFor="let l of lead.leads">
            <div class="col-1">
                <img height="28" [src]="getPartnerLogo(l.property?.partner_kId)"/>
            </div>
            <div class="col-5">
              <a class="link_notUnderLine font-16" target="_blank" rel="noopener noreferrer"
                 href="{{l.property?.link}}}">
                {{l.property?.partner_ref}}
              </a>
            </div>
            <div class="col-1">
              <a rel="nofollow noopener noreferrer" class="link_notUnderLine font-16" target="_blank"
                 href="/accommodation/property/{{l.property_id}}">
                <img height="28" src="/assets/img/admin/picto/logo1.png"/>
              </a>
            </div>
            <div class="col-1">{{l.property?.price}}€</div>
            <div class="col-1 text-truncate">
              {{l.city_group}}
            </div>
            <div class="col-3 border-end">{{l.created_at | date:'short':'':'FR' }}</div>
          </div>
        </div>
        <div class="col-2 ps-4 row custom-div">
          <div class="col-10">
            <div class="bg-light br-8 fst-italic clickable p-4 line-clamp" *ngIf="lead.user.careDatas?.note; else elseBlock"
                 (click)="leaveNote(noteModale,lead)" style="overflow-wrap: break-word;">
              {{lead.user.careDatas.note}}
            </div>
            <ng-template class="text-center" #elseBlock>
              <button class="btn border-0 p-0 text-underlined w-fit-content" (click)="leaveNote(noteModale,lead)">
                {{'Mettre une note'}}
              </button>
            </ng-template>
          </div>
          <div class="col-2 status">
            <div *ngIf="lead.user.careDatas?.status; else elseStatus">
              <mat-form-field appearance="fill" class="font-14 status-form-field" [ngClass]="getOptionClass(lead.user.careDatas?.status)">
                <mat-select class="mediumGray" [(value)] = lead.user.careDatas.status>
                  <mat-option (click)="sendStatus(status, lead)" *ngFor="let status of statusList" [ngClass]="{'selected' : lead.user.careDatas.status === status}" [value]="status">{{printStatus(status)}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <ng-template class="text-center" #elseStatus>
              <mat-form-field appearance="fill" class="font-14 status-form-field" [ngClass]="getOptionClass(lead.user.careDatas?.status)">
                <mat-select class="mediumGray">
                  <mat-option (click)="sendStatus(status, lead)" *ngFor="let status of statusList" [value]="status">{{printStatus(status)}}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="col-12 mt-2 text-center" *ngIf="leadArray && leadArray.length == 0">
        Aucun lead correspondant n'a été trouvé
      </div>
    </div>
</div>

<ng-template #noteModale let-modal>
  <div class="mt-4 px-4 d-flex align-items-center">
    <h5 class="font-trueno-bold font-28 fw-bold">Mettre une note</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <form [formGroup]="formNote" (ngSubmit)="sendNote()" class="pb-4 mt-2 px-4 pt-2">
      <textarea name="content" id="content" cols="30" rows="4" class="form-control"
                formControlName="content"></textarea>
    <button class="btn btn-primary mt-4 w-100" (click)="sendNote()" [disabled]="isSending" *ngIf="activeLead">
      <span *ngIf="isSending" class="spinner-border spinner-border-sm v-middle"></span>
      Sauvegarder la note
    </button>
  </form>
</ng-template>



